import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './style.css'; // Import navigation styles

function Navigation() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    // Close mobile menu when route changes
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMobileMenuOpen && !event.target.closest('.main-navigation')) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [isMobileMenuOpen]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    const navigationItems = [
        { path: '/', label: 'Home', icon: '🏠' },
        { path: '/chat-interface', label: 'AI Diagnosis', icon: '🤖' },
        { path: '/symptom-checker', label: 'Symptom Checker', icon: '🔍' },
        { path: '/articles', label: 'Fish Health Articles', icon: '📚' }
    ];

    const isActive = (path) => {
        if (path === '/' && location.pathname === '/') return true;
        if (path !== '/' && location.pathname.startsWith(path)) return true;
        return false;
    };

    return (
        <nav className="main-navigation">
            <div className="nav-container">
                {/* Logo/Brand */}
                <Link to="/" className="nav-brand">
                    <img 
                        src="/favicon.ico" 
                        alt="Fish MD Logo" 
                        className="brand-logo"
                    />
                    <span className="brand-text">Fish MD</span>
                </Link>

                {/* Desktop Navigation Links */}
                <div className="nav-links-desktop">
                    {navigationItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-text">{item.label}</span>
                        </Link>
                    ))}
                </div>

                {/* Mobile Menu Toggle */}
                <button 
                    className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-label="Toggle navigation menu"
                >
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                </button>

                {/* Mobile Navigation Menu */}
                <div className={`nav-links-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
                    <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
                    <div className="mobile-menu-content">
                        <div className="mobile-menu-header">
                            <button 
                                className="mobile-menu-close"
                                onClick={closeMobileMenu}
                                aria-label="Close navigation menu"
                            >
                                ✕
                            </button>
                            <img 
                                src="/favicon.ico" 
                                alt="Fish MD Logo" 
                                className="mobile-brand-logo"
                            />
                            <span className="mobile-brand-text">Fish MD Navigation</span>
                        </div>
                        <div className="mobile-nav-links">
                            {navigationItems.map((item) => (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`mobile-nav-link ${isActive(item.path) ? 'active' : ''}`}
                                >
                                    <span className="mobile-nav-icon">{item.icon}</span>
                                    <span className="mobile-nav-text">{item.label}</span>
                                    <span className="mobile-nav-arrow">→</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navigation; 